import axios from 'axios';
import * as config from 'config';

let api_url;
if (process.env.NODE_ENV==='development') {
	api_url = 'http://' + config.crm + '.hookah.work/api/app';
} else {
	api_url = '/api';
}

const api = axios.create({
	baseURL: api_url,
	timeout: 3000,
	//headers: {'Authorization': 'Bearer jxubG6rQTYG7DiAl_h3zENKofwcQlDaw'}
});

export default api;



// WEBPACK FOOTER //
// ./src/core/api.js